import React from 'react';

const s = {
  section: {
    padding: '100px 0',
    background: 'linear-gradient(180deg, #050815, #080d20)',
    position: 'relative',
  },
  container: { maxWidth: 1100, margin: '0 auto', padding: '0 24px' },
  header: { textAlign: 'center', marginBottom: 64 },
  tag: {
    display: 'inline-flex', alignItems: 'center', gap: 6,
    background: 'rgba(108,99,255,0.1)', border: '1px solid rgba(108,99,255,0.25)',
    borderRadius: 100, padding: '5px 14px',
    fontSize: 11, fontFamily: 'Sora, sans-serif', fontWeight: 500,
    color: '#a5a0ff', marginBottom: 20,
  },
  h2: {
    fontFamily: 'Sora, sans-serif', fontSize: 42, fontWeight: 800,
    lineHeight: 1.15, marginBottom: 16,
  },
  purple: {
    background: 'linear-gradient(135deg, #6c63ff, #818cf8)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
  },
  subtext: {
    color: '#8892b0', fontSize: 16, maxWidth: 560, margin: '0 auto',
    fontFamily: 'DM Sans, sans-serif', lineHeight: 1.7,
  },
  grid: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20,
  },
  card: {
    background: 'rgba(13,18,41,0.8)',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 16, padding: 28,
    transition: 'all 0.3s ease', cursor: 'default',
  },
  iconWrap: {
    width: 46, height: 46, borderRadius: 12,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    marginBottom: 18, fontSize: 20,
  },
  cardTitle: {
    fontFamily: 'Sora, sans-serif', fontSize: 16, fontWeight: 700,
    marginBottom: 10, color: '#f0f4ff',
  },
  cardDesc: {
    fontSize: 13, color: '#8892b0', lineHeight: 1.65,
    fontFamily: 'DM Sans, sans-serif',
  },
};

const features = [
  {
    icon: '🏢', color: 'rgba(108,99,255,0.2)', border: 'rgba(108,99,255,0.35)',
    title: 'Multi-Empresa',
    desc: 'Administra múltiples empresas desde una sola plataforma. Cada organización cuenta con su propio espacio aislado y completamente seguro.',
  },
  {
    icon: '👥', color: 'rgba(59,130,246,0.2)', border: 'rgba(59,130,246,0.35)',
    title: 'Multi-Usuario',
    desc: 'Gestiona equipos completos con roles diferenciados: Administrador, Gerente y Usuario, cada uno con accesos y permisos personalizados.',
  },
  {
    icon: '🔒', color: 'rgba(34,197,94,0.15)', border: 'rgba(34,197,94,0.3)',
    title: 'Permisos Granulares',
    desc: 'Define permisos precisos por archivo o carpeta: ver, editar, descargar y compartir. Control total sobre quién accede a cada documento.',
  },
  {
    icon: '🔄', color: 'rgba(245,158,11,0.15)', border: 'rgba(245,158,11,0.3)',
    title: 'Control de Versiones',
    desc: 'Historial completo de cambios por archivo. Restaura versiones anteriores, compara modificaciones y nunca pierdas información importante.',
  },
  {
    icon: '💬', color: 'rgba(236,72,153,0.15)', border: 'rgba(236,72,153,0.3)',
    title: 'Comentarios y Colaboración',
    desc: 'Añade comentarios directamente en los archivos, responde en hilos de conversación y mantén a tu equipo sincronizado en tiempo real.',
  },
  {
    icon: '📂', color: 'rgba(168,85,247,0.15)', border: 'rgba(168,85,247,0.3)',
    title: 'Explorador Intuitivo',
    desc: 'Navega por carpetas con una interfaz familiar tipo explorador de archivos. Vista lista o cuadrícula, arrastrar y soltar, y búsqueda instantánea.',
  },
  {
    icon: '🔍', color: 'rgba(20,184,166,0.15)', border: 'rgba(20,184,166,0.3)',
    title: 'Búsqueda Avanzada',
    desc: 'Encuentra cualquier archivo en segundos con búsqueda por nombre, contenido, etiquetas, fecha de modificación o usuario responsable.',
  },
  {
    icon: '🛡️', color: 'rgba(239,68,68,0.15)', border: 'rgba(239,68,68,0.3)',
    title: 'Seguridad Empresarial',
    desc: 'Cifrado de extremo a extremo, autenticación de dos factores y auditoría completa de todas las acciones realizadas en la plataforma.',
  },
  {
    icon: '⚡', color: 'rgba(250,204,21,0.15)', border: 'rgba(250,204,21,0.3)',
    title: 'Alto Rendimiento',
    desc: 'Infraestructura en la nube con 99.9% de disponibilidad garantizada. Carga y descarga rápida de archivos sin importar su tamaño.',
  },
];

export default function Features() {
  return (
    <section style={s.section} id="beneficios">
      <div style={s.container}>
        <div style={s.header}>
          <div style={s.tag}>✨ Características Principales</div>
          <h2 style={s.h2}>
            Todo lo que tu empresa <span style={s.purple}>necesita</span>
          </h2>
          <p style={s.subtext}>
            ArchiVex combina potencia empresarial con simplicidad de uso para que tu
            equipo sea más productivo desde el primer día de implementación.
          </p>
        </div>
        <div style={s.grid}>
          {features.map((f) => (
            <div key={f.title} style={s.card}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = 'rgba(108,99,255,0.35)';
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{ ...s.iconWrap, background: f.color, border: `1px solid ${f.border}` }}>
                {f.icon}
              </div>
              <div style={s.cardTitle}>{f.title}</div>
              <div style={s.cardDesc}>{f.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
